import { useState } from "react";

const LS_KEY = "scanapp_wb";
const DEFAULTS = { threshold: 19, brightness: 33, contrast: 94, enabled: false };

export function useWbSettings() {
  const [settings, setSettings] = useState(() => {
    try {
      const s = localStorage.getItem(LS_KEY);
      if (s) return { ...DEFAULTS, ...JSON.parse(s) };
    } catch {}
    return { ...DEFAULTS };
  });

  const update = (partial) =>
    setSettings(prev => {
      const next = { ...prev, ...partial };
      try { localStorage.setItem(LS_KEY, JSON.stringify(next)); } catch {}
      return next;
    });

  return [settings, update];
}
